module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ed-modal', {
    attrs: {
      "title": 'Mensagem Email :: ' + _vm.formData.id,
      "modal": _vm.showFormMsg,
      "width": "95%",
      "isModal": false
    }
  }, [_c('div', {
    attrs: {
      "slot": "modal-content"
    },
    slot: "modal-content"
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.formData.mensagem)
    }
  })])]), _vm._v(" "), _c('ed-table', {
    attrs: {
      "onSearch": _vm.getLog,
      "onFilter": _vm.getLog,
      "onRegister": _vm.onRegister ? _vm.onRegister : null,
      "tableHead": _vm.tableHead,
      "tableData": _vm.tableData,
      "loadingTable": _vm.loadingTable,
      "pagination": _vm.pagination,
      "response": _vm.response,
      "disabledConfigCell": _vm.disabledConfigCell,
      "filterBadge": _vm.filterBadge,
      "disableCheckAll": ""
    }
  }, [_c('div', {
    attrs: {
      "slot": "table-filter-content"
    },
    slot: "table-filter-content"
  }, [_c('ed-form', {
    attrs: {
      "data": _vm.formFilter,
      "config": _vm.config,
      "response": _vm.response,
      "itens": _vm.filterItems
    }
  })], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5da2a7d6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/web/log/email/index.vue
// module id = 1487
// module chunks = 45